import { ReactNode } from 'react'
import { TypographyP } from './typographyComponents'

interface Props {
  children: ReactNode
  value: string
  ['data-cy']?: string
}

function TableRow({ children, value, 'data-cy': dataCy }: Readonly<Props>) {
  return (
    <div className="flex border-b" data-cy={dataCy}>
      <div className="flex flex-1 items-center border-b-neutral-80 p-4">
        {children}
      </div>
      <div className="flex flex-1 items-center justify-end bg-white p-4">
        <TypographyP>{value}</TypographyP>
      </div>
    </div>
  )
}

export default TableRow
